// src/api/pushTokenApi.js
// Wraps the Spring backend's /pushtoken endpoint (com.experience.pushtoken.PushTokenController).
import axiosClient from "./axiosClient";

export const registerPushToken = async ({ token, userEmail, platform, timezone }) => {
  await axiosClient.post("/pushtoken", { token, userEmail, platform, timezone });
};
